import { matchPath } from "react-router-dom";

import { GENERAL_ROUTES } from "./routes";

export interface GitBookRouteParams {
  pageId?: string;
  pagePath?: string;
}

export const getGitBookRouteParamsFromPathname = (
  pathname: string
): GitBookRouteParams | null => {
  const pageByIdMatch = matchPath(GENERAL_ROUTES.GetInspiredPageById, pathname);
  if (pageByIdMatch?.params.pageId) {
    return { pageId: pageByIdMatch.params.pageId };
  }

  const docsMatch = matchPath(GENERAL_ROUTES.GetInspiredDoc, pathname);
  if (!docsMatch) {
    return null;
  }

  return { pagePath: docsMatch.params["*"] ?? "" };
};

export const isGetInspiredYouTubePath = (pathname: string): boolean => {
  return Boolean(matchPath(GENERAL_ROUTES.GetInspiredYouTube, pathname));
};
